var _excluded = ["color", "borderColor"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { deprecatedPropType, getPaletteColor } from 'pcln-design-system';

var PopoverArrow = function PopoverArrow(_ref) {
  var arrowProps = _ref.arrowProps,
      placement = _ref.placement,
      borderColor = _ref.borderColor,
      color = _ref.color,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Arrow, {
    className: className,
    style: arrowProps.style,
    "data-placement": placement,
    borderColor: borderColor,
    color: color,
    "aria-hidden": "true",
    "data-testid": "popover-arrow"
  }, /*#__PURE__*/React.createElement("div", {
    ref: arrowProps.ref
  }));
};

var ArrowAlignment = function ArrowAlignment() {
  return "\n    &[data-placement*=\"right\"] {\n      left: 0;\n    }\n    &[data-placement*=\"left\"] {\n      right: 0;\n    }\n    &[data-placement*=\"top\"] {\n      bottom: 0;\n    }\n    &[data-placement*=\"bottom\"] {\n      top: 0;\n    }\n    &[data-placement*=\"bottom\"]::before,\n    &[data-placement*=\"right\"]::before,\n    &[data-placement*=\"top\"]::after,\n    &[data-placement*=\"left\"]::after {\n      content: '';\n      position: absolute;\n      width: 0;\n      height: 0;\n      margin: auto;\n      border-style: solid;\n      transform-origin: 0 0;\n      transform: rotate(-45deg);\n      border-width: 6px;\n    }\n  ";
};

var ArrowPlacement = function ArrowPlacement(_ref2) {
  var color = _ref2.color,
      borderColor = _ref2.borderColor,
      props = _objectWithoutProperties(_ref2, _excluded);

  var bgColor = getPaletteColor(color, 'base')(props);
  var brColor = getPaletteColor(borderColor, 'base')(props);
  return "\n    &[data-placement*=\"right\"]::before {\n      left: 8px;\n      border-color: ".concat(bgColor, " transparent transparent ").concat(bgColor, ";\n      box-shadow: -0.75px -0.75px 0px 0.25px ").concat(brColor, ";\n    }\n    &[data-placement*=\"left\"]::after {\n      right: 13px;\n      border-color: transparent ").concat(bgColor, " ").concat(bgColor, " transparent;\n      box-shadow: 0.75px 0.75px 0px 0.25px ").concat(brColor, ";\n    }\n    &[data-placement*=\"top\"]::after {\n      top: -16px;\n      margin-left: -5px;\n      border-color: transparent transparent ").concat(bgColor, " ").concat(bgColor, ";\n      box-shadow: -0.75px 0.75px 0px 0.25px ").concat(brColor, ";\n    }\n    &[data-placement*=\"bottom\"]::before {\n      top: 16px;\n      margin-left: -5px;\n      border-color: ").concat(bgColor, " ").concat(bgColor, " transparent transparent;\n      box-shadow: 0.75px -0.75px 0px 0.25px ").concat(brColor, ";\n    }\n  ");
};

var Arrow = styled.span.withConfig({
  displayName: "Arrow",
  componentId: "sc-1svjbfl-0"
})(["position:absolute;", " ", ""], ArrowAlignment, ArrowPlacement);
PopoverArrow.propTypes = {
  arrowProps: PropTypes.shape({
    ref: PropTypes.func,
    style: PropTypes.object
  }).isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
  bg: deprecatedPropType('color'),
  borderColor: PropTypes.string,
  placement: PropTypes.string
};
PopoverArrow.defaultProps = {
  placement: 'top'
};
export default PopoverArrow;